export class LigneFinancementSecteur {
         id: number | undefined;
         code: string;
         montant: number;
         libelle: string;
  activityAreaId:string;
         ligneFinancementMarcheId: number;

       }